module.exports = __webpack_public_path__ + "media/customizations/regencyatnorthskye/back-26801372488eff3ad9072cc5ad918d56.jpg";